import { PageRequest } from '@/core/request/PageRequest';
import { InstallmentSituation } from '../AccountPayable/AccountPayable.types';

export enum FinancialConsultInstallmentSituation {
  open = 'domain.enums.situation_installment_consult.open',
  canceled = 'domain.enums.situation_installment_consult.canceled',
  settled = 'domain.enums.situation_installment_consult.settled',
}

export const FinancialConsultInstallmentSituationType: Record<
  FinancialConsultInstallmentSituation,
  { label: string; color: string }
> = {
  [FinancialConsultInstallmentSituation.open]: {
    label: 'Aberta',
    color: 'blue',
  },
  [FinancialConsultInstallmentSituation.canceled]: {
    label: 'Cancelado',
    color: 'green',
  },
  [FinancialConsultInstallmentSituation.settled]: {
    label: 'Liquidada',
    color: 'red',
  },
};

export interface FinancialConsultPayableBind {
  consultationId: number;
  mainPayableId: number;
  mainInstallmentPayableId: number;
}

export interface FinancialConsultReceivableBind {
  consultationId: number;
  mainReceivableId: number;
  mainInstallmentReceivableId: number;
}

export interface FinancialConsultListRequest extends PageRequest {
  search?: string;
  code?: string;
  companyId?: number;
  creditor?: string;
  description?: string;
  documentType?: string;
  dueDate?: string;
  payDate?: string;
  emissionDate?: string;
  situation?: InstallmentSituation;
  installmentValue?: number;
  documentNumber?: string;
  observation?: string;
}

export type FinancialConsultPayableListRequest = FinancialConsultListRequest & {
  creditor?: string;
};

export type FinancialConsultReceivableListRequest =
  FinancialConsultListRequest & {
    debtor?: string;
  };

export interface FinancialConsult {
  id: number;
  accountConsultationId: number;
  code: string;
  companyName: string;
  user: string;
  creditor: string;
  description: string;
  dueDate: string;
  payDate?: string;
  emissionDate?: string;
  situation: FinancialConsultInstallmentSituation;
  installmentValue: number;
  discountIncrease: number;
  bankAccount: string;
  costCenter: string;
  planAccount: string;
  documentType: string;
  installmentNumber: number;
  documentNumber: string;
  observation?: string;
  boundAccountConsultation: {
    mainId: number | null;
    mainInstallmentId: number | null;
  };
}

export type FinancialConsultPayable = FinancialConsult & { creditor: string };
export type FinancialConsultReceivable = FinancialConsult & {
  debtor: string;
  rateValue?: number;
};
